import axios from "axios";
import { BaseUrl } from "../Container/BaseUrl/BaseUrl";
import { toast } from "react-toastify";
import { toaststyle } from "./toaststyle";

export const CreateAbandoned = () => {
  axios
    .post(
      BaseUrl + "/users/callcreateSession",
      {
        name: "",
        email_id: "",
        phone: localStorage.getItem("incomingNumber"),
        channel: "voice",
        latitude: "",
        longitute: "",
        skillset:
          localStorage.getItem("SkillSet") == "null"
            ? "NA"
            : localStorage.getItem("SkillSet"),
        language: "English",
        complaint: "",
        agent_id: JSON.parse(localStorage.getItem("tokenAgent")).id,
        agent_extension: localStorage.getItem("AvayaUsername"),
        direction: "Inbound",
        contactId: localStorage.getItem("contactId"),
        UUID_contactId: localStorage.getItem("contactId"),
        UUID_externalContactId: "",
        UUID_calledDeviceID: "",
        UUID_callingDeviceID: "",
        UUID_callingAgentName: "",
        UUID_skillSet:
          localStorage.getItem("SkillSet") == "null"
            ? "NA"
            : localStorage.getItem("SkillSet"),
        isabandoned: true,
        callArrivalTime: localStorage.getItem("callArrivalTime"),
      },
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantid: localStorage.getItem("TenantId"),
        },
      }
    )
    .then(async (res) => {
      if (res.data.status == true) {
        localStorage.removeItem("incomingNumber");
        localStorage.removeItem("callArrivalTime");
        localStorage.removeItem("SkillSet");
        localStorage.removeItem("contactId");
        localStorage.removeItem("mainContactId");
      } else {
        toast.error("Something went Wrong", toaststyle);
        localStorage.removeItem("incomingNumber");
        localStorage.removeItem("callArrivalTime");
        localStorage.removeItem("SkillSet");
        localStorage.removeItem("contactId");
        localStorage.removeItem("mainContactId");
      }
    })
    .catch((err) => {
      console.log("err", err);
    });
};
